import clsx from "clsx"
import { Separator as SeparatorPrimitive } from "radix-ui"
import { forwardRef } from "react"

import type { SX } from "../../theme"
import styles from "./Separator.module.css"

export interface SeparatorProps {
  color?: "grey" | "purple" | "tomato"

  /**
   * Either `vertical` or `horizontal`. Defaults to `horizontal`.
   */
  orientation?: "horizontal" | "vertical"

  /**
   * Whether or not the component is purely decorative. When true, accessibility-related attributes
   * are updated so that that the rendered element is removed from the accessibility tree.
   * Defaults to false.
   */
  decorative?: boolean

  /**
   * The style of the Separator. Defaults to "solid".
   */
  style?: "solid" | "dashed"

  sx?: SX
}

export const Separator = forwardRef<HTMLDivElement, SeparatorProps>(
  function Separator(props, ref) {
    const {
      sx,
      color = "grey",
      orientation = "horizontal",
      decorative = false,
      style = "solid",
      ...otherProps
    } = props

    return (
      <SeparatorPrimitive.Root
        {...otherProps}
        ref={ref}
        orientation={orientation}
        decorative={decorative}
        className={clsx(
          styles.root,
          styles[`color-${color}`],
          styles[orientation],
          styles[style],
        )}
        style={sx}
      />
    )
  },
)
